import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { privacyHead } from "@/lib/route-seo";

export const Route = createFileRoute("/privacy-policy")({
  head: () => privacyHead(),
  component: PrivacyPolicy,
});
